import React from 'react';
import { AntInput, AntTextArea } from 'controls/react/ant/antInput';
import { AntSelect } from 'controls/react/ant/ant-select/antSelect';
import { SimpleField } from 'areas/administration/authentication/types';

export const renderInput = (field: SimpleField) => {
	if (field.kind == 'select') {
		return <AntSelect options={field.options} />;
	}

	if (field.multiline) {
		return <AntTextArea height={80} autoComplete={'new-password'} />;
	}

	if (field.kind == 'password' || field.kind == 'secret') {
		return <AntInput type={'password'} autoComplete={'new-password'} />;
	}

	return <AntInput />;
};
